import { ResumeSettings } from '../../types';

interface SettingsSectionProps {
    settings: ResumeSettings;
    onChange: (settings: ResumeSettings) => void;
}

export function SettingsSection({ settings, onChange }: SettingsSectionProps) {
    return (
        <div className="card">
            <h2 className="section-title">Layout Settings</h2>

            <div className="space-y-4">
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="compactSpacing"
                        checked={settings.compactSpacing}
                        onChange={(e) => onChange({ ...settings, compactSpacing: e.target.checked })}
                        className="mr-2"
                    />
                    <label htmlFor="compactSpacing" className="text-sm text-gray-700">
                        Use compact spacing (fits more content)
                    </label>
                </div>

                <div>
                    <label className="label">Maximum bullet point length (characters)</label>
                    <input
                        type="number"
                        value={settings.maxBulletLength}
                        onChange={(e) => onChange({ ...settings, maxBulletLength: parseInt(e.target.value) })}
                        className="input"
                        min="50"
                        max="500"
                    />
                    <p className="text-xs text-gray-500 mt-1">
                        Recommended: 150 characters for optimal ATS compatibility
                    </p>
                </div>
            </div>
        </div>
    );
}
